module.exports = __webpack_public_path__ + "img/DailBehennah-KyokoKumai-MarietteRousseau-Vermette-TamikoKawata.a271a00c.jpg";